import React, { FC, useEffect, useState } from 'react'
import ShortcutsSubMenu from './ShortcutsSubMenu'
import styles from './Homepage.module.scss'
import { useSelector } from 'react-redux'
import { getHeroItems } from '../selectors'
import HeroCarousel from 'components/SA/Carousel/HeroCarousel/HeroCarousel'
import { getFirstName, isAuthenticated as getIsAuthenticated } from 'selectors/user/session'
import classNames from 'classnames'
import { getIsInitialLoadReady } from 'selectors/user/isInitialLoadReady'
import HeaderSectionSkeleton from './HeaderSectionSkeleton'

const HeaderSection: FC = () => {
  const [homepageCopyTitle, setHomepageCopyTitle] = useState(
    'Experience the Joy of Living with Original Art'
  )
  const isInitialLoadReady = useSelector(getIsInitialLoadReady)
  const isAuthenticated = useSelector(getIsAuthenticated)
  const userFirstName = useSelector(getFirstName)
  const heroItems = useSelector(getHeroItems)
  const heroCarouselImages = heroItems.map(
    ({ jpgLarge, title, description, ctaText, ctaLink, ctaTheme }) => ({
      src: jpgLarge,
      alt: title,
      title,
      description,
      ctaLink,
      ctaText,
      ctaTheme,
    })
  )

  useEffect(() => {
    if (isAuthenticated) {
      setHomepageCopyTitle(`Welcome Back, `)
    }
  }, [isAuthenticated, userFirstName])

  return (
    <div className={styles.headerSection}>
      {isInitialLoadReady ? (
        <>
          <div className={styles.headerSectionHeroTilesContainer}>
            <HeroCarousel items={heroCarouselImages} />
            <div
              className={classNames(styles.defaultGripWrapper, styles.shortcutsSubMenuWrapper, {
                [styles.shortcutsSubMenuWrapperLoggedIn]: isAuthenticated,
              })}
            >
              <ShortcutsSubMenu />
            </div>

            <div className={styles.defaultGripWrapper}>
              <h1
                className={classNames({
                  [styles.homepageH1Title]: !isAuthenticated,
                  [styles.firstNameTitle]: isAuthenticated,
                })}
              >
                {homepageCopyTitle}
                <span>{userFirstName}.</span>
              </h1>
            </div>
          </div>
        </>
      ) : (
        <HeaderSectionSkeleton />
      )}
    </div>
  )
}

export default HeaderSection
